/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hwaccel_BodyInputs */

const en_hwaccel_body = /** @type {(inputs: Hwaccel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser is rendering 3D in software, which may feel slow. Enabling hardware acceleration in your browser settings will give you a much smoother experience.`)
};

const fr_hwaccel_body = /** @type {(inputs: Hwaccel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre navigateur effectue le rendu 3D en mode logiciel, ce qui peut ralentir l'expérience. Activer l'accélération matérielle dans les paramètres du navigateur résoudra le problème.`)
};

const ms_sg2_hwaccel_body = /** @type {(inputs: Hwaccel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelayar anda memaparkan 3D dalam mod perisian, yang mungkin terasa perlahan. Mengaktifkan pecutan perkakasan dalam tetapan pelayar akan memberi pengalaman yang lebih lancar.`)
};

/**
* | output |
* | --- |
* | "Your browser is rendering 3D in software, which may feel slow. Enabling hardware acceleration in your browser settings will give you a much smoother experience." |
*
* @param {Hwaccel_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const hwaccel_body = /** @type {((inputs?: Hwaccel_BodyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hwaccel_BodyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hwaccel_body(inputs)
	if (locale === "fr") return fr_hwaccel_body(inputs)
	return ms_sg2_hwaccel_body(inputs)
});